import { render, staticRenderFns } from "./EditInfobox.vue?vue&type=template&id=12286cd0&"
import script from "./EditInfobox.vue?vue&type=script&lang=js&"
export * from "./EditInfobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports